import { PersonalItemBaseDirective } from '$core/base/_personal-item.component';
import { AddressesService } from '$core/services/addresses.service';
import { AuthenticationService } from '$core/services/auth.service';
import { SwalService } from '$core/shell/swal/swal.service';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild,
} from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { untilDestroyed } from '$core/operators/until-destroyed.operator';
import { BehaviorSubject } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { DownloadInvoiceParams, InvoiceFileType } from '../../models/invoice';
import { InvoicesService } from '../../services';
import * as dayjs from 'dayjs';

@Component({
  selector: 'app-invoice-item',
  templateUrl: './invoice-item.component.html',
  styleUrls: ['./invoice-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvoiceItemComponent
  extends PersonalItemBaseDirective<any>
  implements OnDestroy
{
  @ViewChild('printBtn', { static: false }) protected printBtn;
  @Output() public selected = new EventEmitter();
  @Input() public compact = false;
  public isDownloading$ = new BehaviorSubject(false);
  public isPrinting$ = new BehaviorSubject(false);
  public printUrl: SafeUrl | undefined;
  public readonly dayjs = dayjs;

  constructor(
    public authService: AuthenticationService,
    protected requestService: AddressesService,
    protected modalService: BsModalService,
    protected swalService: SwalService,
    protected translates: TranslateService,
    private invoicesService: InvoicesService,
    private cd: ChangeDetectorRef
  ) {
    super(authService, requestService, modalService, swalService, translates);
  }

  public ngOnDestroy(): void {}

  public onSelect(): void {
    this.selected.emit();
  }

  public print(): void {
    if (!this.printUrl) {
      this.isPrinting$.next(true);
      this.invoicesService
        .print(this.item.id)
        .pipe(
          untilDestroyed(this),
          finalize(() => {
            this.isPrinting$.next(false);
          })
        )
        .subscribe((res: any) => {
          this.printUrl = URL.createObjectURL(res);
          this.openPrintModel();
        });
    } else {
      this.openPrintModel();
    }
  }

  public openPrintModel(): void {
    if (this.printUrl) {
      setTimeout(() => {
        this.printBtn.nativeElement.click();
        this.printUrl = false;
        this.cd.detectChanges();
      });
    }
  }

  public downloadInvoiceByType(type?: InvoiceFileType): void {
    const params: DownloadInvoiceParams = { type };
    this.isDownloading$.next(true);
    this.invoicesService
      .downloadInvoice(this.item.id, params)
      .pipe(
        finalize(() => {
          this.isDownloading$.next(false);
        }),
        untilDestroyed(this)
      )
      .subscribe();
  }
}
